import { memo, useMemo } from 'react';
import { Flex, Modal, Typography } from 'antd';
import { FormikProps } from 'formik';
import { MButton, MInput, MTextArea } from '@Components/Base';

import styles from './bsa-notification.module.css';

import { initFormikValuesType } from './types';

interface BSANotificationProps {
  title: string;
  textSuccessBtn: string;
  isModalOpen: boolean;
  formik: FormikProps<initFormikValuesType>;
  handleSuccess: () => void;
  handleCancel: () => void;
  textCancelBtn?: string;
}

const BSANotification: React.FC<BSANotificationProps> = ({
  title,
  isModalOpen,
  textSuccessBtn,
  textCancelBtn = 'No, Thanks',
  formik,
  handleSuccess,
  handleCancel,
}) => {
  const customButtons = useMemo(() => {
    return [
      <MButton key="back" type="tertiary" onClick={handleCancel}>
        {textCancelBtn}
      </MButton>,
      <MButton key="submit" type="primary" onClick={handleSuccess}>
        {textSuccessBtn}
      </MButton>,
    ];
  }, [textCancelBtn, textSuccessBtn, handleSuccess, handleCancel]);

  return (
    <Modal
      open={isModalOpen}
      onOk={handleSuccess}
      onCancel={handleCancel}
      className={styles.modal}
      footer={customButtons}
      closeIcon={false}
    >
      <Flex vertical>
        <Flex className={styles.titleSection}>
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        </Flex>
        <div className={styles.fieldsSection}>
          <div>
            <Typography.Text>Email ID / Username:</Typography.Text>
            <MInput
              name="userName"
              onChange={(input) =>
                formik.setFieldValue('username', input.target.value)
              }
              placeholder="Type Username or Email ID"
            />
          </div>

          <div>
            <Typography.Text>Password:</Typography.Text>
            <MInput
              name="password"
              onChange={(input) =>
                formik.setFieldValue('password', input.target.value)
              }
              placeholder="Type Password"
            />
          </div>

          <div>
            <Typography.Text>Comments:</Typography.Text>
            <MTextArea
              name="comments"
              onChange={(input) =>
                formik.setFieldValue('comment', input.target.value)
              }
              rows={4}
              showCount
              maxLength={100}
              placeholder="Enter your comments (if any)..."
            />
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default memo(BSANotification);
